import SmileyLoadingSpinner from "@/assets/SmileySpinner.svg?react";

export const FullScreenLoadingSpinner = ({ message }: { message: string }) => {
  return (
    <div className="fixed inset-0 z-[99] flex h-screen items-center justify-center backdrop-blur-xl">
      <div className="flex flex-col gap-8">
        <SmileyLoadingSpinner
          data-testid="spinner"
          className="mx-auto animate-spin"
        />
        <p className="font-semibold text-primary-100">{message}</p>
      </div>
    </div>
  );
};
